/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, memo } from 'react'
import { MaterialReactTable } from 'material-react-table'
import { useTranslation } from 'react-i18next'
import ExportCsv from '../ExportCsv'
import ImageContainer from '../../Pages/SmartCatalog/MultiImageContainer'
import { CancelButton, DateTime } from '../../../irmlib/src/components/FormControls'
import { today, getMonth } from '../../../irmlib/src/common'
import { ContainedButton, Label, MenuButton, OutlinedButton, ThemeButton } from '../../../irmlib/src/components/Controls'
import { MoreVert } from 'irmlib/icons'
// import { useTheme } from 'irmlib/styles'
import * as gdeTransactionLite from '../../../services/firestore/gdeTransactionsLite'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { clearBusy, closeGeneralDialog, openGeneralDialog, setBusy, successToast } from '../../../irmlib/src/containers'
import { useTheme, XDivider, FlexByRowCentered } from '../../../irmlib/src/styles'
import { useHistory } from 'react-router-dom'
import * as routePaths from '../../../navigation/routePaths'
import * as constants from '../../../irmlib/src/common/constants'
import Button from '@mui/material/Button'
import PropTypes from 'prop-types'
import { useMergeState, useFormPageHandler } from 'irmlib/hooks'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Tooltip, TextField, Chip, Stack } from '@mui/material'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { YDivider } from 'irmlib/styles'
import { TemplateAndRefOnImgCature } from '../../Pages/SmartCatalog/MenuActivities'
import RequestTemplateFormat from '../../Pages/Template/RequestListTemplate'
import { Delete } from '@mui/icons-material'
import { Visibility } from '@material-ui/icons'

const minWidth = '100px'

const initialState = {
  columnsNew: [],
  transmittalId: false,
  templateId: false
}

const BatchLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`
const NumBoxContainer = styled(TextField)`
  minWidth:150px;
`

const BottomPaddedButton = props =>
  <>
    <ThemeButton {...props} />
  </>

/*eslint-disable*/
const MaterialTable = memo((props) => {
  const { data, activeTab: propActiveTab, tableFor, editedRows, setEditedRows, disableRowSelection, isError, setIsError } = props
  const [selectedImageIndex, setSelectedImageIndex] = useState(null)
  const [, setState, getState] = useMergeState(initialState)
  const [selectedImage, setSelectedImage] = useState(null)
  const [tableData, setTableData] = useState([])
  // const [transmittalId, setTransmittalId] = useState(false)
  const tableRef = useRef()
  const refLocalBusyCursor = useRef(null)

  const [activeTab, setActiveTab] = useState(propActiveTab === 'bulk_upload_review' ? 'bulk_upload_review' : 'box')
  const [sortMsg, setSortMsg] = useState('')
  const [selectLvls, setSelectLvls] = useState({accountLevel1: '', accountLevel2: '', accountLevel3: ''})
  
  const { i18n, t } = useTranslation()
  const theme = useTheme()
  const history = useHistory()

  useEffect(() => {
    if (data && data.length > 0 && typeof setEditedRows === 'function') {
      // Deep clone data to prevent mutating original data
      const clonedData = data.map(row => ({
        ...row,
        imgDetails: {
          ...row.imgDetails,
          numOfFiles: row.imgDetails?.numOfFiles || ''
        }
      }))

      setEditedRows(clonedData)
    }
  }, [data])

  useEffect(()=>{
    sortedBy(selectLvls)
  }, [selectLvls])

  
  // Action items to be selected
  const menuItems = [
    { value: 'retake', id: 'retakeMenu_transmittal', label: t('jobStatusObj.Retake'), style: { color: theme.palette.primary.main } },
    { value: 'reprocess', id: 'reprocessMenu_transmittal', label: t('buttons.reprocess'), style: { color: theme.palette.primary.main } },
    { value: 'cancel', id: 'cancelMenu_transmittal', label: t('forms.cancel'), style: { color: theme.palette.primary.main } }
  ]
  
  // action items for bulk pload transmittals
  const menuItems2 = [
    { value: 'change_ref_image', id: 'retakeMenu_transmittal', label: t('Search.ChangeRefImage2'), style: { color: theme.palette.primary.main } },
    { value: 'change_template', id: 'reprocessMenu_transmittal', label: t('Search.ChangeTemplate2'), style: { color: theme.palette.primary.main } },
  ]

  const formTemplate = [
    {
      label: 'smartCatalog.scanBoxBarcode',
      fieldKey: 'scanBoxBarcode',
      isRequired: true,
      isRequiredError: 'forms.required',
    },
    {
      label: 'templates.assetType',
      fieldKey: 'assetType',
      isRequired: true,
      isRequiredError: 'forms.required',
    },
    {
      label: 'templates.assetSequence',
      fieldKey: 'assetSequence',
      isRequired: true,
      isRequiredError: 'forms.required',
    },
    {
      label: 'dropdowns.changeToChange',
      fieldKey: 'changeToChange',
      // isRequired: true,
      // isRequiredError: 'forms.required',
    },
  ]

  const getService = async (setState) => {
    const getObject = {
    }
    return Promise.resolve(getObject)
  }
  
  const [arrRefs, formData] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const getRequest = async() => {
    let templateData = await gdeTransactions.getTemplateById_SC(getState()?.templateId)
    templateData = templateData.data()
    const data = {
      accountLevel1: templateData?.accountLevel1 || '',
      accountLevel2: templateData?.accountLevel2 || '',
      accountLevel3: templateData?.accountLevel3 || '',
      assetType: templateData?.assetType || '',
      templateType: templateData?.templateType || '',
      wmsInstance: templateData?.wmsCode || '',
    }
    const {accountLevel1:l1, accountLevel2:l2, accountLevel3:l3} = templateData
    setSelectLvls({accountLevel1:l1, accountLevel2:l2, accountLevel3:l3})

    const requests = await gdeTransactions.getRequests(data)
    const requestList = []
    requests.forEach((doc) => {
      requestList.push(doc.data())
    })
    setState({
      templateData: requestList,
    })
  }

  const getRequestFields = async () => {
    await getRequest()
    const fields = getState().templateData
    fields.sort((a, b) => {
      return (new Date(b.createdTS)) - (new Date(a.createdTS))
    })
    const resultPromises = fields.map(doc => {
      const templateFields = Object.keys(doc.template).map((key) => {
        const data = `${key} (${doc.template[key].fieldId})`
        return data
      })
      
      return gdeTransactions.getUserNameById(doc.workerId).then(createdBy => {
        return {
          requestId: doc.requestId,
          requestFields: templateFields,
          customTemplateName: doc.customTemplateName,
          createdBy: createdBy,
          createdOn: doc.createdTS,
          imgReference: doc.imgReference
        }
      })
    })
    const result = await Promise.all(resultPromises)
    return result
  }

  const sortedBy = (selectLvls) => {
  let sortbyMsg = `Lvl1: ${selectLvls.accountLevel1}`
  if (selectLvls.accountLevel2 !== ''){
      sortbyMsg += ` | Lvl2: ${selectLvls.accountLevel2}`
  }
  if (selectLvls.accountLevel3 !== ''){
      sortbyMsg += ` | Lvl3: ${selectLvls.accountLevel3}`
  }
  setSortMsg(sortbyMsg) 
}

  const ContentForDialogBox2 = ({ sortMsg }) => {
    return (
    <>
    <div>
    <h4>Template sorted by: {sortMsg}</h4>
    </div>
      <RequestTemplateFormat
        tableRef={tableRef}
        getPageData={getRequestFields}
        title={getState().templateName}
        formTemplates={formTemplate}
        arrRefs={arrRefs}
        isEdit={false}
        getState={getState}
        selectedRecord={onCheckBoxSelection}
        currentTemplateId={getState()?.templateId}
        fromMultiReqs={false}
        reportFor={'multiRequestSelection'}
      />
      </>
    )
  }

  const onCheckBoxSelection = async(requestId) => {
    if (requestId && requestId !== getState()?.newTemplateId) {
      setState({
        newTemplateId: requestId,
        selectedTemplate: requestId,
      })
    }
  }

  // 1330: ResponseDetails for Transmittals
  const showRequestList = async (rowData) => {
    const imageDocs = await gdeTransactions.getSelectedFormat(rowData?.id)
    const constructUserFields = (imageDocs) => {
      const templateData = Object.values(imageDocs[0]?.template).map(item => item.fieldId)
      let columnsResponse = []

      columnsResponse =
        templateData.map((item) => ({
          header: item,
          accessorKey: item,
          Cell: ({ cell, row }) => {
            const fieldName = item
            const errors = row.original.errors || {}
            return (
              <div>
                <span>
                  {cell.getValue()}
                </span>
                {errors[fieldName] && (
                  <div style={{ color: 'red', fontSize: '0.8em' }}>
                    {errors[fieldName]}
                  </div>
                )}
              </div>
            )
          }
        }))
      columnsResponse = columnsResponse.map((col) => {
        const headerLength = col.header.length
        let minWidth = 0
        if (headerLength < 8) {
          minWidth = headerLength * 8
        } else {
          minWidth = headerLength * 15
        }
        return {
          ...col,
          minSize: minWidth,
          muiTableHeadCellProps: {
            sx: {
              whiteSpace: 'nowrap',
              wordWrap: 'break-word',
              minWidth: `${minWidth}px`,
              overflow: 'visible',
              color: '#58595B',
              fontWeight: 'bold',
            },
          },
          muiTableBodyCellProps: {
            sx: {
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }
          },
        }
      })
      setState({ columnsNew: columnsResponse })
      return imageDocs.flatMap((box) => {
        if (!box.idpResponse) {
          return []
        }
        if (!box.formatError) {
          return []
        }
        const processFields = (fields, folder, isLocked = false) => {
          return Object.entries(fields).reduce((result, [fieldName, fieldData]) => {
            const { fieldId } = fieldData
            if (box.idpResponse[folder]) {
              result[fieldId] = isLocked
                ? fieldData.lockedValue
                : box.idpResponse[folder][fieldName] || ''

              const error = box?.formatErrorInfo?.[folder]?.[fieldName]
              if (error) {
                result.errors = { ...result.errors, [fieldId]: error }
              }
              // result.boxId = box.skpBoxNbr
            }
            return result
          }, {})
        }

        return Object.keys(box.idpResponse)
          .sort()
          .map((folder) => {
            const userFields1 = processFields(box?.template, folder)
            // const userFields2 = processFields(box?.templateLocked, folder, true)
            return { ...userFields1 }
          })
      })
    }

    const responseData = constructUserFields(imageDocs)
    
    openGeneralDialog({
      title: t('routeTitles.responseDetails'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox columns={getState()?.columnsNew} columnsData={responseData} />,
      buttons: <ButtonsForTemplateAssign handleCancel={handleCancel} />,
      closeX: true
    })
  }

  const showWmsFailedResp = async (rowData) => {
    const imageDocs = await gdeTransactionLite.getWmsFailedResp(rowData?.id)
    imageDocs.sort((a, b) => {
      const aDate = new Date(a.updatedTs)
      const bDate = new Date(b.updatedTs)
      return bDate - aDate
    })
    
    const constructUserFields = (imageDocs) => {
      const templateData = Object.keys(imageDocs[0]?.response?.response?.lineItems[0])
        .sort()
        .map((it) => {
          if (it === 'error') {
            return 'WMS Error'
          } else if (it === 'boxNumber') {
            return 'Box Number'
          } else {
            return it
          }
        })
        .filter((e) => !(['success', 'customerBoxNumber'].includes(e)))
      let columnsResponse = []

      columnsResponse =
        templateData.map((item) => ({
          header: item,
          accessorKey: item,
          Cell: ({ cell, row }) => {
            const fieldName = item
            const errors = row.original.errors || {}
            return (
              <div>
                <span>
                  {cell.getValue()}
                </span>
                {errors[fieldName] && (
                  <div style={{ color: 'red', fontSize: '0.8em' }}>
                    {errors[fieldName]}
                  </div>
                )}
              </div>
            )
          }
        }))
      columnsResponse = columnsResponse.map((col) => {
        const headerLength = col.header.length
        let minWidth = 0
        if (headerLength < 5) {
          minWidth = headerLength * 8
        } else {
          minWidth = headerLength * 15
        }
        return {
          ...col,
          minSize: minWidth,
          muiTableHeadCellProps: {
            sx: {
              whiteSpace: 'nowrap',
              wordWrap: 'break-word',
              minWidth: `${minWidth}px`,
              overflow: 'visible',
              color: '#58595B',
              fontWeight: 'bold',
            },
          },
          muiTableBodyCellProps: {
            sx: {
              whiteSpace: 'normal',
              // wordWrap: 'break-word',
              // wordBreak: 'break-word',
              // overflowWrap: 'break-word',
              width: 'auto'
            }
          },
        }
      })
      setState({ columnsNew: columnsResponse })
      return imageDocs[0]?.response?.response?.lineItems.filter((e) => e?.success !== 'true').map((item) => {
        const newObj = {}
        Object.keys(item).forEach((it) => {
          if (it === 'error') {
            newObj.errors = { 'WMS Error': item[it] }
          } else if (it === 'boxNumber') {
            newObj['Box Number'] = item[it]
          } else {
            newObj[it] = item[it]
          }
        })
        
        return newObj
      })
    }

    const responseData = constructUserFields(imageDocs)
    openGeneralDialog({
      title: t('routeTitles.wmsResponseDetails'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox columns={getState()?.columnsNew} columnsData={responseData} />,
      buttons: <ButtonsForTemplateAssign handleCancel={handleCancel} />,
      closeX: true
    })
  }

  const handleDeleteTransmittal = (rowData) => {
    openGeneralDialog({
      title: <FlexByRowCentered><Label noTranslate='true'>{t('Search.DeleteJob')}</Label></FlexByRowCentered>,
      message: t('toast.confiemDeleteMsg'),
      buttons:
    <>
      <CancelButton onClick={handleCancel} />
      <XDivider width='10px' />
      <ContainedButton onClick={deleteTransmittal(rowData.id)}>buttons.yes</ContainedButton>
    </>,
      closeX: true
    })
  }

  const handleCancel = () => {
    closeGeneralDialog()
  }

  const deleteTransmittal = async(transmittalId) => {
    await gdeTransactions.deleteTransmittal(transmittalId)
    successToast({ message: t('toast.deleteTransmittal', { transmittalId: transmittalId }), title: t('toast.success'), autoHideDuration: 3000 })
    closeGeneralDialog()
  }

  const ContentForDeleteBox = (props) => (
    <>
      <Label noTranlate={true}>{props.t('smartCatalog.deleteTransmittalCofirmationMsg')}</Label>
      <Label noTranlate={true}>{props.t('Search.DeleteBoxContent2')}</Label>
      <VerticalDivider />
    </>
  )
  
  ContentForDeleteBox.propTypes = {
    t: PropTypes.any,
  }

  const DeleteBox = (props) => (
    <>
      <VerticalDivider />
      <XDivider width='35px' />
      <OutlinedButton
        id={'templateSearch_delete_cancel'}
        style={{ minWidth }}
        onClick={props.handleCancel}
      >
        Search.Cancel
      </OutlinedButton>
      <ContainedButton
        id={'templateSearch_delete_yes'}
        style={{ minWidth }}
        onClick={props.handleDelete}
      >
        Search.yes
      </ContainedButton>
      <XDivider width='35px' />
    </>
  )
  
  DeleteBox.propTypes = {
    handleCancel: PropTypes.func,
    handleDelete: PropTypes.func,
  }
  
  const handleCalcelDeleteBox = () => {
    closeGeneralDialog()
  }

  const VerticalDivider = () => <YDivider height='50px' />

  const handleDelete = async (data) => {
    try {
      await gdeTransactions.deleteTransmittal(data?.id)
      successToast({ message: t('toast.deletedTransmittal'), title: t('toast.success') }, 15)
      closeGeneralDialog()
    } catch (error) {
      console.error('Delete failed:', error)
    }
  }


  const openDeleteBoxDialog = (rowdata) => {
    openGeneralDialog({
      title: t('smartCatalog.deleteTransmittalWarning'),
      message: <ContentForDeleteBox t={t} />,
      translateMessage: false,
      noTranslateTitle: true,
      closeX: true,
      buttons: (
        <DeleteBox
          handleCancel={handleCalcelDeleteBox}
          handleDelete={() => handleDelete(rowdata)}
        />
      ),
    })
    return Promise.resolve()
  }

  const selectToDelete = async (rowdata) => {
    openDeleteBoxDialog(rowdata)
  }



  const ButtonsForTemplateAssign = props =>
    <>
      <CancelButton id={'addBoxTransmittal_button_cancel'} onClick={props.handleCancel} />
      <XDivider width='10px' />
    </>
  
  ButtonsForTemplateAssign.propTypes = {
    handleCancel: PropTypes.func,
  }

  // 1330: ResponseDetails for Transmittals
  const ContentForDialogBox = (props) => {
    const normalData = props.columnsData
    const normalColumns = props.columns
    const columnsResponse = normalColumns.filter((col) =>
      normalData.some((row) => {
        const hasdata = row[col.accessorKey] !== '' && row[col.accessorKey] !== undefined && row[col.accessorKey] !== null
        const hasError = row.errors?.[col.accessorKey] && row.errors[col.accessorKey] !== ''
        return hasdata || hasError
      })
    )
    const responseData = normalData.filter((row) =>
      row.errors !== undefined
    )

    return (
      <MaterialReactTable
        columns={columnsResponse}
        data={responseData}
        enableColumnFilters={true}
        enableRowSelection
        enableExport={true}
        enableGlobalFilter
        enableColumnFilter
        enableColumnSorting
        enableGrouping={true}
        enableColumnResizing={true}
        muiTableHeadCellProps={{
          sx: {
            color: '#58595B',
            fontWeight: 'bold',
          },
        }}
        initialState={{
          density: 'compact'
        }}
        renderTopToolbarCustomActions={({ table, data }) => {
          const isDisabled = !table.getIsSomeRowsSelected()
          const isNoData = responseData?.length === 0
          const isNoPageData = responseData?.length > 4
          return (
            <ExportCsv
              columns={columnsResponse}
              isDisabled={isDisabled}
              isNoData={isNoData}
              isNoPageData={isNoPageData}
              table={table}
            />
          )
        }}
        tableFor={'smart_catalog'}
      />
    )
  }

  /* eslint-disable */
  // Defining columns in the Material React Table format
  let columns = []
if (props?.tableFor === 'bulk_upload_transmittals') {
    columns = [
    {
    header: t('tableColumns.action'),
    accessorKey: 'modify',
    Cell: ({ row }) => {
      const itemsForMenu = menuItems2
      return (
        itemsForMenu
          ? <>
          <MenuButton
            key={row?.original?.id}
            id={'viewBoxTransmittals_ellipsis'}
            buttonIcon={<MoreVert />}
            items={itemsForMenu}
            onSelect={(value) => selectAction2(value, row?.original, row?.original?.id)}
          /><Delete
          onClick={(value) => selectAction3(value, row?.original, row?.original?.id)}
          style={{ cursor: 'pointer' }}
          />
          </>
          : null
      )
    }
  },
  {
    header: t('templates.transmittalId'),
    accessorKey: 'id',
  },
  {
  accessorKey: 'numOfBoxes',
  header: t('tableColumns.numOfBoxes'),
  grow: true,
  Cell: ({ row }) => {
  const [value, setValue] = useState(row.original.imgDetails?.numOfFiles || '')
  const [error, setError] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)

  const handleBlur = () => {
    props.setEditedRows(prev => {
      const existingIndex = prev.findIndex(r => r.id === row.original.id)

      const updatedRow = {
        ...row.original,
        imgDetails: {
          ...row.original.imgDetails,
          numOfFiles: value,
        }
      }

      if (existingIndex === -1) {
        return [...prev, updatedRow]
      } else {
        const copy = [...prev]
        copy[existingIndex] = updatedRow
        return copy
      }
    })
  }
  const validateNumOfBoxes = (numOfBoxes) => {
    const totNoOfBoxes = numOfBoxes
    if(totNoOfBoxes === '') {
      setIsError(true)
      setIsEmpty(true)
      setError(false)
      setValue(numOfBoxes)
    }
      else if (totNoOfBoxes > 50) {
        setIsError(true)
        setIsEmpty(false)
        setError(true)
        setValue(numOfBoxes)
      } else {
        setIsError(false)
        setIsEmpty(false)
        setError(false)
        setValue(numOfBoxes)
      }
  } 

  return (
    <NumBoxContainer
      value={value}
      inputProps={{
        maxLength: 2,
        inputMode: 'numeric',
        pattern: '[0-9]*',
        onInput: (e) => { 
                      e.target.value = e?.target?.value?.replace(/[^0-9]/g, '') 
                    }
      }}
      onChange={(e) => validateNumOfBoxes(e.target.value)}
      onBlur={handleBlur}
      variant="outlined"
      size="small"
      helperText={
        <span style={{ color: isError ? 'red' : 'black', wordBreak: 'normal', whiteSpace: 'normal', display: 'block', overflowWrap: 'normal' , maxWidth: '100%', }}>
        {error ? t(`${'messages.savePop'}`) : ''}
        {isEmpty ? t(`${'toast.cantEmpty'}`) : ''}
        </span>
      }
    />
  )
}
  },
  {
    accessorKey: 'imgDetails',
    header: t('tableColumns.images'),
    Cell: ({ row }) => {
      const images = row?.original?.imgDetails?.imgPath
      // Add safety checks: ensure images exists, is an array, and has at least one element
      if (!images || !Array.isArray(images) || images.length === 0) {
        return <div style={{ width: '100px', height: '70px' }}>-</div>
      }
      return (
        <img
          src={images[0]}
          alt='images'
          style={{ width: '100px', height: '70px', cursor: 'pointer' }}
          onClick={() => {
            handleOpen(0)
            setSelectedImage(images)
          }}
        />
      )
    },
  },
  {
    header: t('tableColumns.templateFields'),
    accessorKey: 'fields',
    grow: true,
  },
  {
    accessorKey: 'imgReference',
    header: t('tableColumns.imgReference'),
    grow: true,
    Cell: ({ row }) => {
      const image = row?.original?.imgReference
      const images = [image]
      return (
        <Visibility
        style={{ cursor: 'pointer', fontSize: 32 }}
          onClick={() => {
            handleOpen(0)
            setSelectedImage(images)
          }}
        />
      )
    },
  },
  // {
  //   accessorKey: 'delete',
  //   header: t('Search.deleteTemplate'),
  //   grow: true
  // },
]
} else {
    columns = [
  {
    header: t('templates.transmittalId'),
    accessorKey: 'id',
  },
  {
    header: t('reports.customerLevel.customerId'),
    accessorKey: 'customerId',
  },
  {
    header: t('templates.batchId'),
    accessorKey: 'batchId',
    Cell: ({ cell }) => {
      const dataIndex = cell.row.index
      const rowdata = tableData[dataIndex]
      return (
        rowdata.batchId 
          ? <BatchLink
            id={`view_Transmittals_${rowdata.batchId}`}
            theme={theme}
            to={{
              pathname: `${routePaths.batchTransmittals}`,
              state: {
                fromAdmin: false,
                rowData: rowdata,
                batchId: rowdata.batchId,
                fromViewBoxTransmittal: true
              }
            }}
          >
            {rowdata.batchId || '-'}
          </BatchLink>
          : '-'
      )
    },
  },
  {
    header: t('templates.building'),
    accessorKey: 'building',
  },
  {
    accessorKey: 'formatError',
    header: t('tableColumns.format'),
  },
  {
    accessorKey: 'status',
    header: t('tableColumns.status'),
    grow: true,
  },
  {
    accessorKey: 'dateCreated',
    header: t('tableColumns.dateCreated'),
    filterFn: (row, columnId, filterValue) => {
      if (!filterValue || filterValue.length === 0) {
        return true
      }
      const filterMonth = new Date(filterValue[0])
      const rowDate = new Date(row.getValue(columnId))

      // Check if the row's date matches the selected month
      return (
        rowDate.getFullYear() === filterMonth.getFullYear() &&
        rowDate.getMonth() === filterMonth.getMonth()
      )
    },
    Filter: ({ column }) => {
      const { getFilterValue, setFilterValue } = column
      return (
        <DateTime
          label={t('tableColumns.dateCreated')}
          type='month'
          minDate={getMonth('2020-01')}
          maxDate={getMonth(today())}
          value={getFilterValue() ? getFilterValue()[0] : null}
          onChange={(selectedMonth) => {
            setFilterValue(selectedMonth ? [selectedMonth] : undefined)
          }}
        />
      )
    },
  },
  {
    accessorKey: 'imgDetails',
    header: t('tableColumns.images'),
    Cell: ({ row }) => {
      const images = row?.original?.imgDetails?.imgPath
      // Add safety checks: ensure images exists, is an array, and has at least one element
      if (!images || !Array.isArray(images) || images.length === 0) {
        return <div style={{ width: '100px', height: '70px' }}>-</div>
      }
      return (
        <img
          src={images[0]}
          alt='images'
          style={{ width: '100px', height: '70px', cursor: 'pointer' }}
          onClick={() => {
            handleOpen(0)
            setSelectedImage(images)
          }}
        />
      )
    },
  },
  {
    header: t('tableColumns.wmsStatus'),
    accessorKey: 'wmsStatus',
  },
  {
    header: t('tableColumns.wmsRegion'),
    accessorKey: 'wmsRegion',
  },
  {
    header: t('tableColumns.templateFields'),
    accessorKey: 'fields',
    grow: true,
  },
  {
    accessorKey: 'imgReference',
    header: t('tableColumns.imgReference'),
    grow: true,
    Cell: ({ row }) => {
      const image = row?.original?.imgReference
      const images = [image]
      return (
        <Visibility
        style={{ cursor: 'pointer', fontSize: 32 }}
         onClick={() => {
            handleOpen(0)
            setSelectedImage(images)
          }}
        />
      )
    },
  },
  {
    accessorKey: 'exception',
    header: t('tableColumns.exceptionMsg'),
    grow: true
  },
  {
    header: t('tableColumns.action'),
    accessorKey: 'modify',
    Cell: ({ row }) => {
      const status = row?.original?.status
      let itemsForMenu
      if (status === t('transmittalTypeObj.pending') || status === t('transmittalTypeObj.processed') || status === t('jobStatusObj.submit')) {
        itemsForMenu = menuItems.filter(item => {
          let result
          if (item.value === 'reprocess' || item.value === 'cancel') {
            result = item
          }
          return result
        })
      } else if (status === t('transmittalTypeObj.uploaded') || status === t('jobStatusObj.Cancelled')) {
        itemsForMenu = null
      } else {
        itemsForMenu = menuItems.filter(item => {
          let result
          if (item.value === 'cancel' || item.value === 'reprocess' || item.value === 'retake') {
            result = item
          }
          return result
        })
      }
      return (
        itemsForMenu
          ? <MenuButton
              key={row?.original?.id}
              id={'viewBoxTransmittals_ellipsis'}
              buttonIcon={<MoreVert />}
              items={itemsForMenu}
              onSelect={(value) => selectAction(row?.original, value, row?.original?.id)}
            />
          : null
      )
    }
  },
  {
    accessorKey: 'flatFileId',
    header: t('tableColumns.fileId'),
    Cell: ({ cell }) => {
      const [copied, setCopied] = useState(false)
      const value = cell.getValue()
      const handleCopy = () => {
        if (value !== '') {
          navigator.clipboard.writeText(value)
          setCopied(true)
          setTimeout(() => setCopied(false), 1000)
        }
      }
      return (
        <Tooltip title={copied ? 'Copied' : 'Click to copy'} arrow placement='top-start'>
          <span onClick={handleCopy}
            style={{ cursor: 'pointer' }}>
            {value}
          </span>
        </Tooltip>
      )
    }
  }
]
}


  // 1330: ResponseDetails for Transmittals
  columns.forEach((column) => {
    if (column.accessorKey === 'formatError') {
      column.header = t('tableColumns.format')
      column.Cell = ({ row }) => {
        const rowdata = row.original
        if (rowdata?.formatError === true) {
          return (
            <Button
              onClick={() => showRequestList(rowdata)}
              variant="contained"
              color="primary"
              size="small"
              style={{ margin: '0 0 0 4px' }}
            >
              {t('buttons.yes')}
            </Button>
          )
        } else {
          const theme = createTheme({
            components: {
              MuiButton: {
                styleOverrides: {
                  root: {
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&.Mui-disabled': {
                      backgroundColor: '#9e9e9e',
                      color: 'white',
                    }
                  }
                }
              }
            }
          })
          return (
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                size="small"
                disabled={true}
                style={{ margin: '0 0 0 4px' }}
              >
                {rowdata?.formatError === '-' ? '-' : t('buttons.no')}
              </Button>
            </ThemeProvider>
          )
        }
      }
    }
    if (column.accessorKey === 'wmsStatus') {
      column.header = t('tableColumns.wmsStatus')
      column.Cell = ({ row }) => {
        const rowdata = row.original
        
        if (rowdata?.wmsStatus === t('wmsResponseStatusObj.Failed')) {
          return (
            <Button
              onClick={() => showWmsFailedResp(rowdata)}
              variant="contained"
              color="primary"
              size="small"
              style={{ margin: '0 0 0 4px', width: '80px' }}
            >
              {t('wmsResponseStatusObj.Failed')}
            </Button>
          )
        } else {
          const theme = createTheme({
            components: {
              MuiButton: {
                styleOverrides: {
                  root: {
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&.Mui-disabled': {
                      backgroundColor: '#9e9e9e',
                      color: 'white',
                    }
                  }
                }
              }
            }
          })
          return (
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                size="small"
                disabled={true}
                style={{ margin: '0 0 0 4px', width: '80px' }}
              >
                {rowdata?.wmsStatus === '-' ? '-' : rowdata?.wmsStatus}
              </Button>
            </ThemeProvider>
          )
        }
      }
    }
  })

  const ButtonsForTemplateAssign2 = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={props.closeTemplateDialog}>buttons.cancel</BottomPaddedButton>
      <BottomPaddedButton color='primary' variant='contained' onClick={props.onNewTemplateSelection}>buttons.cancelAndGoBack</BottomPaddedButton>
    </>
  
    ButtonsForTemplateAssign2.propTypes = {
      arrRefs: PropTypes.array,
      saveAndAssignJob: PropTypes.func,
      onNewTemplateSelection: PropTypes.func,
      closeTemplateDialog: PropTypes.func
    }

  useEffect(() => {
    if (props?.tableFor === 'smart_catalog_view_transmittals' || props?.tableFor === 'bulk_upload_transmittals') {
      const fetchData = async () => {
        try {
          const currentData = props?.data
          // this is to match the data from currentData that are corresponding to the table columns
          const formattedData = currentData.map((item) => {
            const newObj = {}
            columns.forEach((column) => {
              if (column.accessorKey === 'status') {
                if (item[column.accessorKey] === 'published') {
                  newObj[column.accessorKey] = t(
                    'jobStatusObj.submit'
                  )
                } else {
                  newObj[column.accessorKey] = t(
                    `transmittalTypeObj.${item[column.accessorKey]}`
                  )
                }
              } else if (column.accessorKey === 'wmsStatus') {
                newObj[column.accessorKey] = t(
                  `wmsResponseStatusObj.${item[column.accessorKey]}`
                )
              } else if (column.accessorKey === 'unapproved') {
                newObj[column.accessorKey] = 'Unapproved'
              } else {
                newObj[column.accessorKey] = item[column.accessorKey]
              }
            })
            return newObj
          })
          setTableData(formattedData)
        } catch (error) {
          // eslint-disable-next-line
          console.error('Error fetching data:', error)
        }
      }
      fetchData()
    }
  }, [props?.data, i18n.language, activeTab])

  const onCancel = () => {
    closeGeneralDialog()
  }

  const handleSelectedRefImage = (data, data1, transmittalId) => {
    const updatedData = {
      imgReference: data,
      imgReferenceURI: data1
      }
    gdeTransactions.updateTransmittal(transmittalId, updatedData)
    successToast({ message: t('toast.templateAndRefChangedSucessfully'), title: t('toast.success') }, 5)
  }

  const onTemplateSelection1 = async () => {
    if (getState().newTemplateId) {
      if (getState().newTemplateId !== getState()?.selectedRequest) {
        const requestData = await gdeTransactionLite.getTemplateById(getState().newTemplateId)
        let customFields = []
        Object.keys(requestData?.template).forEach(function(key) {
          customFields.push(key)
        })

        // setState({
        //   customFields: customFields,
        //   templateFields: requestData?.template,
        //   templateFieldsLocked: requestData?.templateLocked,
        //   selectedReqFields: customFields,
        //   newTemplateSelected: true,
        //   unlockedTemplateFields: [],
        //   lockedTemplateFields: [],
        // })

      const activityData = {
      template: requestData?.template,
      templateID: getState()?.newTemplateId, 
      updatedTs: (new Date()).toISOString(),
    }
    // templateImgCount: 0
    await gdeTransactions.updateTransmittal(getState()?.transmittalId, activityData)
      }
      successToast({ message: t('toast.templateChangedSucessfully'), title: t('toast.success') }, 5)
      closeGeneralDialog()
    } else {
      closeGeneralDialog()
    }
  }

  const closeTemplateDialog = () => {
    closeGeneralDialog()
  }

  const openUpdateRefImageDialog = (rowData) => {
    openGeneralDialog({
      title: t('templates.refImageUpdate', { boxId: rowData.id }),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <TemplateAndRefOnImgCature rowData={rowData} selectedTemplateData={handleSelectedRefImage} onClose={onCancel} />,
      closeX: false
    })
  }

  const onUpdateTemplateDialog = async() => {
    openGeneralDialog({
      title: t('smartCatalog.templates'),
      maxWidth: 'lg',
      noTranslateTitle: true,
      message: <ContentForDialogBox2 sortMsg={sortMsg} />,
      buttons: <ButtonsForTemplateAssign2 closeTemplateDialog={closeTemplateDialog} arrRefs={arrRefs} onNewTemplateSelection={onTemplateSelection1} />,
      closeX: true
    })
    // setError('')
  }
  // Performing api call as per the respective action
  const handleAction = async (rowDataa, action, transmittalId) => {
    setBusy()
    if (action === 'cancel') {
      const data = {
        status: constants.transmittalStatus.cancelled,
        exception: '',
        hitl: {},
        // statusCode: '',
        isActive: false,
        updatedTs: (new Date()).toISOString()
      }
      await gdeTransactions.updateTransmittal(transmittalId, data)
      successToast({ message: t('toast.cancelledTransmittal', { transmittalId: transmittalId }), title: t('toast.success'), autoHideDuration: 3000 })
    } else if (action === 'retake') {
      if (rowDataa?.batchId !== undefined) {
        history.push(`${routePaths.uploadBoxTransmittals}/retake/${transmittalId}`)
      } else {
        history.push(`${routePaths.addBoxTransmittals}/retake/${transmittalId}`)
      }
    } else if (action === 'reprocess') {
      const data = {
        status: constants.transmittalStatus.pending,
        isReprocess: true,
        idp: {},
        idpResponse: {},
        idpMessageId: '',
        formatError: false,
        formatErrorInfo: {},
        updatedTs: (new Date()).toISOString(),
        processedAt: '',
        publishedAt: ''
      }
      await gdeTransactions.updateTransmittal(transmittalId, data)
      successToast({ message: t('toast.reprocessedTransmittal', { transmittalId: transmittalId }), title: t('toast.success'), autoHideDuration: 3000 })
    }
    closeGeneralDialog()
    clearBusy()
  }

    const handleAction2 = async (action, data, transmittalId) => {
    setBusy()
    if (action === 'change_ref_image') {
      openUpdateRefImageDialog(data)
      // successToast({ message: t('toast.cancelledTransmittal', { transmittalId: transmittalId }), title: t('toast.success'), autoHideDuration: 3000 })
    } else if (action === 'change_template') {
      onUpdateTemplateDialog(transmittalId)
    }
    else if (action === 'delete_transmittal') {
      openDeleteBoxDialog(data)    
    }
    clearBusy()
  }

  // Display of dilog modal customized to actions
  const selectAction = (rowDataa, value, transmittalId) => {
    return (
      openGeneralDialog({
        title: <Label noTranslate={true}>{(value === 'cancel' && t('options.cancelTransmittal')) || (value === 'retake' && t('jobStatusObj.Retake')) || (value === 'reprocess' && t('options.reprocessTransmittal'))}</Label>,
        message: (value === 'cancel' && t('options.cancelTransmittalMessage', { transmittalId: transmittalId })) || (value === 'retake' && t('options.retakeTransmittalMessage', { transmittalId: transmittalId })) || (value === 'reprocess' && t('options.reprocessTransmittalMessage', { transmittalId: transmittalId })),
        buttons: <>
          <CancelButton onClick={onCancel} />
          <XDivider width='10px' />
          <ContainedButton onClick={() => handleAction(rowDataa, value, transmittalId)} >buttons.yes</ContainedButton>
        </>
      })
    )
  }

  const selectAction2 = async (value, rowData, transmittalId) => {
    const data = await gdeTransactions.getTransmittal(transmittalId)
    setState({ transmittalId: transmittalId, templateId: data?.templateID})
    return (
      openGeneralDialog({
        title: <Label noTranslate={true}>{(value === 'change_ref_image' && t('Search.ChangeRefImage2')) || value === 'change_template' && t('Search.ChangeTemplate2') || value === 'delete_transmittal' && t('smartCatalog.deleteTransmittalWarning')}</Label>,
        message: (value === 'change_ref_image' && t('buttons.changeRefImgMsg', { transmittalId: transmittalId })) || (value === 'change_template' && t('buttons.changeTemplateMsg', { transmittalId: transmittalId })) || (value === 'delete_transmittal' && t('toast.confiemDeleteMsg', { transmittalId: transmittalId })),
        buttons: <>
          <CancelButton onClick={onCancel} />
          <XDivider width='10px' />
          <ContainedButton onClick={() => handleAction2(value, rowData, transmittalId)} >buttons.yes</ContainedButton>
        </>
      })
    )
  }
  const selectAction3 = async (value, rowData, transmittalId) => {
    openDeleteBoxDialog(rowData)
  }

  const handleClose = () => {
    setSelectedImageIndex(null)
  }

  const MultiImageContainer = () => (
    <div>
      {selectedImageIndex !== null && (
        <ImageContainer
          images={selectedImage}
          selectedImageIndex={selectedImageIndex}
          handleClose={handleClose}
        />
      )}
    </div>
  )

  const handleOpen = (index) => {
    setSelectedImageIndex(index)
  }

  return (
    <>
      <MaterialReactTable
        columns={columns}
        data={tableData}
        muiTableHeadCellProps={{
          sx: {
            color: '#58595B',
            fontWeight: 'bold',
          },
        }}
        enableRowSelection={disableRowSelection ? false : true}
        enableMultiRowSelection={disableRowSelection ? false : true}
        enableExport={true}
        enableGlobalFilter
        enableColumnFilter
        enableColumnSorting
        enableGrouping={true}
        enableColumnResizing={true}
        initialState={{
          sorting: [
            {
              id: 'dateCreated',
              desc: true,
            },
          ],
          columnVisibility: { imgReference: true, modify: true },
          density: 'compact',
        }}
        renderTopToolbarCustomActions={({ table }) => {
          const isDisabled = !table.getIsSomeRowsSelected()
          const isNoData = tableData?.length === 0
          const isNoPageData = tableData?.length > 4
          const hideExportSelectedData = disableRowSelection ? true : false
          const hideExportPageData = disableRowSelection ? true : false
          return (
            <>
            <ExportCsv
              columns={columns}
              isDisabled={isDisabled}
              isNoData={isNoData}
              isNoPageData={isNoPageData}
              table={table}
              hideExportSelectedData={hideExportSelectedData}
              hideExportPageData={hideExportPageData}              
            />
            </>
          )
        }}
      />
      <MultiImageContainer />
    </>
  )
})

export default MaterialTable
